import type { ComputedRef } from 'vue';
import type { ProgressPoint } from '../interfaces/progressBar.interface';
import { UPSALE_MILESTONES } from '../common/constants/upsaleMilestones';

export function useUpsaleMilestones(): ComputedRef<ProgressPoint[]> {
  const { t } = useI18n();

  return computed(() => UPSALE_MILESTONES.map(({ icon, labelKey, activeFrom }) => ({
    icon,
    label: t(labelKey),
    activeFrom,
  })));
}
